// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seller-action-center {
    --sac-border: #dce6df;
    --sac-ink: #1d2e23;
    --sac-muted: #607067;
    --sac-primary: #316c29;
    background:
        radial-gradient(circle at 100% 0, rgba(49, 108, 41, 0.06), transparent 22rem),
        #f8fbf9;
    border: 1px solid var(--sac-border);
    color: var(--sac-ink);
    padding: clamp(1rem, 2.5vw, 2rem);
}

.seller-action-center > h2 {
    font-size: clamp(1.25rem, 2.4vw, 1.65rem);
    letter-spacing: -0.025em;
    margin-bottom: 1rem;
}

.seller-action-center > .content {
    margin-top: 0;
}

.seller-action-center__header {
    align-items: center;
    display: flex;
    gap: 1.5rem;
    justify-content: space-between;
    margin: -0.25rem 0 1.25rem;
}

.seller-action-center__header p {
    color: var(--sac-muted);
    font-size: 0.9rem;
    margin: 0;
}

.seller-action-center__header strong {
    color: var(--sac-primary);
    display: block;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.11em;
    margin-bottom: 0.2rem;
    text-transform: uppercase;
}

.seller-action-center__spark {
    align-items: center;
    background: #edf5ec;
    border: 1px solid #c9dec6;
    border-radius: 11px;
    color: var(--sac-primary);
    display: flex;
    flex: 0 0 42px;
    height: 42px;
    justify-content: center;
}

.seller-action-center__categories {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.seller-action-category {
    --category-accent: #316c29;
    --category-soft: #e8f3e6;
    align-items: flex-start;
    appearance: none;
    background: #fff;
    border: 1px solid var(--sac-border);
    border-radius: 12px;
    color: var(--sac-ink);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font: inherit;
    gap: 0.65rem;
    min-height: 148px;
    padding: 0.85rem;
    position: relative;
    text-align: left;
    transition:
        border-color 160ms ease,
        box-shadow 160ms ease,
        transform 160ms ease;
}

.seller-action-category::before {
    background: var(--category-accent);
    border-radius: 14px 14px 0 0;
    content: '';
    height: 2px;
    left: 12px;
    opacity: 0;
    position: absolute;
    right: 12px;
    top: -1px;
    transform: scaleX(0.45);
    transition: opacity 160ms ease, transform 160ms ease;
}

.seller-action-category:hover {
    border-color: color-mix(in srgb, var(--category-accent) 42%, var(--sac-border));
    box-shadow: 0 6px 16px rgba(29, 46, 35, 0.07);
    transform: translateY(-1px);
}

.seller-action-category:focus-visible {
    outline: 3px solid color-mix(in srgb, var(--category-accent) 35%, transparent);
    outline-offset: 2px;
}

.seller-action-category--expanded {
    background: color-mix(in srgb, var(--category-soft) 30%, #fff);
    border-color: color-mix(in srgb, var(--category-accent) 62%, var(--sac-border));
    box-shadow: 0 6px 16px rgba(29, 46, 35, 0.08);
}

.seller-action-category--expanded::before {
    opacity: 1;
    transform: scaleX(1);
}

.seller-action-category--products {
    --category-accent: #316c29;
    --category-soft: #e8f3e6;
}

.seller-action-category--invoices {
    --category-accent: #4963a8;
    --category-soft: #edf0fa;
}

.seller-action-category--orders {
    --category-accent: #b05f22;
    --category-soft: #fbefe6;
}

.seller-action-category--website {
    --category-accent: #8a477f;
    --category-soft: #f7ebf5;
}

.seller-action-category--payments {
    --category-accent: #267b70;
    --category-soft: #e7f5f2;
}

.seller-action-category--integrations {
    --category-accent: #7255a5;
    --category-soft: #f0ebf8;
}

.seller-action-category--analytics {
    --category-accent: #28719a;
    --category-soft: #e7f3f8;
}

.seller-action-category--help {
    --category-accent: #a54b5e;
    --category-soft: #faeaee;
}

.seller-action-category__icon,
.seller-action-panel__icon {
    align-items: center;
    background: var(--category-soft);
    border-radius: 9px;
    color: var(--category-accent);
    display: inline-flex;
    flex: 0 0 auto;
    height: 34px;
    justify-content: center;
    width: 34px;
}

.seller-action-category__copy {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.25rem;
}

.seller-action-category__copy strong {
    font-size: 0.95rem;
    line-height: 1.2;
}

.seller-action-category__copy span {
    color: var(--sac-muted);
    font-size: 0.78rem;
    line-height: 1.45;
}

.seller-action-category__meta {
    align-items: center;
    color: var(--category-accent);
    display: flex;
    font-size: 0.72rem;
    font-weight: 700;
    justify-content: space-between;
    width: 100%;
}

.seller-action-category__meta i {
    transition: transform 160ms ease;
}

.seller-action-category--expanded .seller-action-category__meta i {
    transform: rotate(180deg);
}

.seller-action-panel {
    --category-accent: #316c29;
    --category-soft: #e8f3e6;
    animation: seller-action-panel-in 180ms ease-out;
    background: #fff;
    border: 1px solid var(--sac-border);
    border-radius: 14px;
    margin-top: 0.75rem;
    padding: clamp(0.85rem, 1.8vw, 1.2rem);
}

.seller-action-panel__back {
    align-items: center;
    appearance: none;
    background: none;
    border: none;
    color: var(--category-accent);
    cursor: pointer;
    display: inline-flex;
    font: inherit;
    font-size: 0.78rem;
    font-weight: 700;
    gap: 0.4rem;
    margin-bottom: 0.75rem;
    padding: 0;
}

.seller-action-panel__back:hover {
    text-decoration: underline;
}

.seller-action-panel__back:focus-visible {
    outline: 3px solid color-mix(in srgb, var(--category-accent) 35%, transparent);
    outline-offset: 2px;
}

.seller-action-panel--invoices {
    --category-accent: #4963a8;
    --category-soft: #edf0fa;
}

.seller-action-panel--orders {
    --category-accent: #b05f22;
    --category-soft: #fbefe6;
}

.seller-action-panel--website {
    --category-accent: #8a477f;
    --category-soft: #f7ebf5;
}

.seller-action-panel--payments {
    --category-accent: #267b70;
    --category-soft: #e7f5f2;
}

.seller-action-panel--integrations {
    --category-accent: #7255a5;
    --category-soft: #f0ebf8;
}

.seller-action-panel--analytics {
    --category-accent: #28719a;
    --category-soft: #e7f3f8;
}

.seller-action-panel--help {
    --category-accent: #a54b5e;
    --category-soft: #faeaee;
}

@keyframes seller-action-panel-in {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.seller-action-panel__heading {
    align-items: center;
    display: flex;
    gap: 0.75rem;
    margin-bottom: 0.8rem;
}

.seller-action-panel__heading p {
    color: var(--category-accent);
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    margin: 0 0 0.15rem;
    text-transform: uppercase;
}

.seller-action-panel__heading h3 {
    color: var(--sac-ink);
    font-size: 1.15rem;
    letter-spacing: -0.015em;
    margin: 0;
}

.seller-action-panel__grid {
    display: grid;
    gap: 0.7rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.seller-action-tile {
    background:
        linear-gradient(
            145deg,
            color-mix(in srgb, var(--category-soft) 22%, #fff) 0,
            #fff 62%
        );
    border: 1px solid color-mix(in srgb, var(--category-accent) 16%, var(--sac-border));
    border-radius: 11px;
    box-shadow: 0 2px 8px rgba(29, 46, 35, 0.04);
    display: flex;
    flex-direction: column;
    min-height: 166px;
    overflow: visible;
    position: relative;
    transition:
        border-color 160ms ease,
        box-shadow 160ms ease,
        transform 160ms ease;
}

.seller-action-tile::before {
    background: var(--category-accent);
    border-radius: 2px;
    bottom: 14px;
    content: '';
    left: -1px;
    position: absolute;
    top: 14px;
    width: 2px;
    opacity: 0.5;
}

.seller-action-tile:hover {
    border-color: color-mix(in srgb, var(--category-accent) 42%, var(--sac-border));
    box-shadow: 0 7px 18px rgba(29, 46, 35, 0.08);
    transform: translateY(-1px);
}

.seller-action-tile__main {
    color: inherit;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 0.85rem 0.85rem 0.6rem 0.95rem;
    text-decoration: none;
}

.seller-action-tile__main:focus-visible {
    border-radius: 11px;
    outline: 3px solid color-mix(in srgb, var(--category-accent) 35%, transparent);
    outline-offset: -3px;
}

.seller-action-tile__icon {
    align-items: center;
    background: color-mix(in srgb, var(--category-soft) 76%, #fff);
    border: 1px solid color-mix(in srgb, var(--category-accent) 16%, transparent);
    border-radius: 8px;
    color: var(--category-accent);
    display: inline-flex;
    font-size: 0.95rem;
    height: 36px;
    justify-content: center;
    margin-bottom: 0.65rem;
    width: 36px;
}

.seller-action-tile__copy {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.25rem;
}

.seller-action-tile__copy strong {
    color: var(--sac-ink);
    font-size: 0.98rem;
    line-height: 1.25;
}

.seller-action-tile__copy > span {
    color: var(--sac-muted);
    font-size: 0.78rem;
    line-height: 1.45;
}

.seller-action-tile__open {
    align-items: center;
    align-self: flex-start;
    color: var(--category-accent);
    display: inline-flex;
    font-size: 0.7rem;
    font-weight: 800;
    gap: 0.4rem;
    margin-top: 0.55rem;
}

.seller-action-tile__open i {
    font-size: 0.65rem;
    transition: transform 160ms ease;
}

.seller-action-tile__main:hover .seller-action-tile__open i {
    transform: translateX(3px);
}

.seller-action-tile__help {
    border-top: 1px solid var(--sac-border);
    background: color-mix(in srgb, var(--category-soft) 14%, transparent);
    border-radius: 0 0 10px 10px;
    padding: 0.5rem 0.85rem 0.55rem 0.95rem;
}

.seller-action-tile__help .hal-label {
    color: var(--category-accent);
    font-size: 0.72rem;
    font-weight: 600;
}

.seller-action-tile__help .hal-icon {
    background: var(--category-accent);
}

@media (max-width: 980px) {
    .seller-action-center__categories {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .seller-action-panel__grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 560px) {
    .seller-action-center {
        padding: 0.65rem;
    }

    .seller-action-center > h2 {
        font-size: 1.1rem;
        margin-bottom: 0.55rem;
    }

    .seller-action-center__header {
        margin: 0 0 0.65rem;
    }

    .seller-action-center__header p {
        font-size: 0.78rem;
        line-height: 1.35;
    }

    .seller-action-center__header strong {
        font-size: 0.62rem;
        margin-bottom: 0.1rem;
    }

    .seller-action-center__spark {
        display: none;
    }

    .seller-action-center__categories {
        gap: 0.45rem;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .seller-action-category {
        gap: 0.4rem;
        min-height: 106px;
        padding: 0.6rem;
    }

    .seller-action-category__icon {
        border-radius: 7px;
        font-size: 0.8rem;
        height: 30px;
        width: 30px;
    }

    .seller-action-category__copy {
        gap: 0;
    }

    .seller-action-category__copy strong {
        font-size: 0.78rem;
        line-height: 1.15;
    }

    .seller-action-category__copy span {
        display: none;
    }

    .seller-action-category__meta {
        font-size: 0.62rem;
    }

    .seller-action-panel {
        margin-top: 0.55rem;
        padding: 0.65rem;
        scroll-margin-top: 0.75rem;
    }

    .seller-action-panel__back {
        font-size: 0.72rem;
        margin-bottom: 0.55rem;
    }

    .seller-action-panel__heading {
        gap: 0.55rem;
        margin-bottom: 0.6rem;
    }

    .seller-action-panel__heading p {
        font-size: 0.6rem;
        letter-spacing: 0.06em;
    }

    .seller-action-panel__heading h3 {
        font-size: 0.95rem;
    }

    .seller-action-panel__grid {
        gap: 0.5rem;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .seller-action-tile, div.page article.seller-action-tile {
        min-height: 0;
        padding: 0.5rem;
    }

    .seller-action-tile__main {
        padding: 0.65rem 0.6rem 0.5rem 0.7rem;
    }

    .seller-action-tile__icon {
        font-size: 0.78rem;
        height: 30px;
        margin-bottom: 0.45rem;
        width: 30px;
    }

    .seller-action-tile__copy {
        gap: 0;
    }

    .seller-action-tile__copy strong {
        font-size: 0.78rem;
        line-height: 1.2;
    }

    .seller-action-tile__copy > span {
        display: none;
    }

    .seller-action-tile__open {
        font-size: 0.62rem;
        margin-top: 0.4rem;
    }

    .seller-action-tile__help {
        padding: 0.4rem 0.6rem 0.45rem 0.7rem;
    }

    .seller-action-tile__help .hal-label {
        font-size: 0.64rem;
    }
}

@media (min-width: 440px) and (max-width: 560px) {
    .seller-action-center__categories {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (prefers-reduced-motion: reduce) {
    .seller-action-category,
    .seller-action-category::before,
    .seller-action-category__meta i,
    .seller-action-panel,
    .seller-action-tile,
    .seller-action-tile::before,
    .seller-action-tile__open i {
        animation: none;
        transition: none;
    }
}

[data-theme="dark"] .seller-action-center {
    --sac-border: #3a463e;
    --sac-ink: #e3ece6;
    --sac-muted: #aab8af;
    background:
        radial-gradient(circle at 100% 0, rgba(93, 158, 77, 0.07), transparent 22rem),
        #17221b;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.24);
}

[data-theme="dark"] .seller-action-center__spark {
    background: #223129;
    border-color: #3a523e;
    color: #9bd381;
}

[data-theme="dark"] .seller-action-category,
[data-theme="dark"] .seller-action-panel {
    background: #1c2620;
}

[data-theme="dark"] .seller-action-tile {
    background:
        linear-gradient(
            145deg,
            color-mix(in srgb, var(--category-accent) 6%, #1c2620) 0,
            #1c2620 62%
        );
}

[data-theme="dark"] .seller-action-category--expanded {
    background: color-mix(in srgb, var(--category-soft) 8%, #1c2620);
}

[data-theme="dark"] .seller-action-category__icon,
[data-theme="dark"] .seller-action-panel__icon {
    background: color-mix(in srgb, var(--category-accent) 18%, #1c2620);
}

[data-theme="dark"] .seller-action-tile__icon {
    background: color-mix(in srgb, var(--category-accent) 12%, #1c2620);
    border-color: color-mix(in srgb, var(--category-accent) 24%, #1c2620);
}

[data-theme="dark"] .seller-action-tile__help {
    background: color-mix(in srgb, var(--category-accent) 4%, #1c2620);
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/SellerActionCenter.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB;;eAEW;IACX,mCAAmC;IACnC,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB;;;4BAGwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,WAAW;IACX,WAAW;IACX,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,oDAAoD;AACxD;;AAEA;IACI,+EAA+E;IAC/E,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,8EAA8E;IAC9E,mBAAmB;AACvB;;AAEA;IACI,8DAA8D;IAC9D,+EAA+E;IAC/E,6CAA6C;AACjD;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;;IAEI,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,gDAAgD;IAChD,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8EAA8E;IAC9E,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gDAAgD;AACpD;;AAEA;IACI;;;;;SAKK;IACL,mFAAmF;IACnF,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;;;4BAGwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,+EAA+E;IAC/E,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,8EAA8E;IAC9E,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,8DAA8D;IAC9D,6EAA6E;IAC7E,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,qEAAqE;IACrE,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,gDAAgD;IACpD;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gDAAgD;IACpD;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,gDAAgD;IACpD;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;;;;;;;QAOI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB;;eAEW;IACX,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI;;;;;SAKK;AACT;;AAEA;IACI,gEAAgE;AACpE;;AAEA;;IAEI,mEAAmE;AACvE;;AAEA;IACI,mEAAmE;IACnE,qEAAqE;AACzE;;AAEA;IACI,kEAAkE;AACtE","sourcesContent":[".seller-action-center {\n    --sac-border: #dce6df;\n    --sac-ink: #1d2e23;\n    --sac-muted: #607067;\n    --sac-primary: #316c29;\n    background:\n        radial-gradient(circle at 100% 0, rgba(49, 108, 41, 0.06), transparent 22rem),\n        #f8fbf9;\n    border: 1px solid var(--sac-border);\n    color: var(--sac-ink);\n    padding: clamp(1rem, 2.5vw, 2rem);\n}\n\n.seller-action-center > h2 {\n    font-size: clamp(1.25rem, 2.4vw, 1.65rem);\n    letter-spacing: -0.025em;\n    margin-bottom: 1rem;\n}\n\n.seller-action-center > .content {\n    margin-top: 0;\n}\n\n.seller-action-center__header {\n    align-items: center;\n    display: flex;\n    gap: 1.5rem;\n    justify-content: space-between;\n    margin: -0.25rem 0 1.25rem;\n}\n\n.seller-action-center__header p {\n    color: var(--sac-muted);\n    font-size: 0.9rem;\n    margin: 0;\n}\n\n.seller-action-center__header strong {\n    color: var(--sac-primary);\n    display: block;\n    font-size: 0.7rem;\n    font-weight: 800;\n    letter-spacing: 0.11em;\n    margin-bottom: 0.2rem;\n    text-transform: uppercase;\n}\n\n.seller-action-center__spark {\n    align-items: center;\n    background: #edf5ec;\n    border: 1px solid #c9dec6;\n    border-radius: 11px;\n    color: var(--sac-primary);\n    display: flex;\n    flex: 0 0 42px;\n    height: 42px;\n    justify-content: center;\n}\n\n.seller-action-center__categories {\n    display: grid;\n    gap: 0.75rem;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.seller-action-category {\n    --category-accent: #316c29;\n    --category-soft: #e8f3e6;\n    align-items: flex-start;\n    appearance: none;\n    background: #fff;\n    border: 1px solid var(--sac-border);\n    border-radius: 12px;\n    color: var(--sac-ink);\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    font: inherit;\n    gap: 0.65rem;\n    min-height: 148px;\n    padding: 0.85rem;\n    position: relative;\n    text-align: left;\n    transition:\n        border-color 160ms ease,\n        box-shadow 160ms ease,\n        transform 160ms ease;\n}\n\n.seller-action-category::before {\n    background: var(--category-accent);\n    border-radius: 14px 14px 0 0;\n    content: '';\n    height: 2px;\n    left: 12px;\n    opacity: 0;\n    position: absolute;\n    right: 12px;\n    top: -1px;\n    transform: scaleX(0.45);\n    transition: opacity 160ms ease, transform 160ms ease;\n}\n\n.seller-action-category:hover {\n    border-color: color-mix(in srgb, var(--category-accent) 42%, var(--sac-border));\n    box-shadow: 0 6px 16px rgba(29, 46, 35, 0.07);\n    transform: translateY(-1px);\n}\n\n.seller-action-category:focus-visible {\n    outline: 3px solid color-mix(in srgb, var(--category-accent) 35%, transparent);\n    outline-offset: 2px;\n}\n\n.seller-action-category--expanded {\n    background: color-mix(in srgb, var(--category-soft) 30%, #fff);\n    border-color: color-mix(in srgb, var(--category-accent) 62%, var(--sac-border));\n    box-shadow: 0 6px 16px rgba(29, 46, 35, 0.08);\n}\n\n.seller-action-category--expanded::before {\n    opacity: 1;\n    transform: scaleX(1);\n}\n\n.seller-action-category--products {\n    --category-accent: #316c29;\n    --category-soft: #e8f3e6;\n}\n\n.seller-action-category--invoices {\n    --category-accent: #4963a8;\n    --category-soft: #edf0fa;\n}\n\n.seller-action-category--orders {\n    --category-accent: #b05f22;\n    --category-soft: #fbefe6;\n}\n\n.seller-action-category--website {\n    --category-accent: #8a477f;\n    --category-soft: #f7ebf5;\n}\n\n.seller-action-category--payments {\n    --category-accent: #267b70;\n    --category-soft: #e7f5f2;\n}\n\n.seller-action-category--integrations {\n    --category-accent: #7255a5;\n    --category-soft: #f0ebf8;\n}\n\n.seller-action-category--analytics {\n    --category-accent: #28719a;\n    --category-soft: #e7f3f8;\n}\n\n.seller-action-category--help {\n    --category-accent: #a54b5e;\n    --category-soft: #faeaee;\n}\n\n.seller-action-category__icon,\n.seller-action-panel__icon {\n    align-items: center;\n    background: var(--category-soft);\n    border-radius: 9px;\n    color: var(--category-accent);\n    display: inline-flex;\n    flex: 0 0 auto;\n    height: 34px;\n    justify-content: center;\n    width: 34px;\n}\n\n.seller-action-category__copy {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.seller-action-category__copy strong {\n    font-size: 0.95rem;\n    line-height: 1.2;\n}\n\n.seller-action-category__copy span {\n    color: var(--sac-muted);\n    font-size: 0.78rem;\n    line-height: 1.45;\n}\n\n.seller-action-category__meta {\n    align-items: center;\n    color: var(--category-accent);\n    display: flex;\n    font-size: 0.72rem;\n    font-weight: 700;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.seller-action-category__meta i {\n    transition: transform 160ms ease;\n}\n\n.seller-action-category--expanded .seller-action-category__meta i {\n    transform: rotate(180deg);\n}\n\n.seller-action-panel {\n    --category-accent: #316c29;\n    --category-soft: #e8f3e6;\n    animation: seller-action-panel-in 180ms ease-out;\n    background: #fff;\n    border: 1px solid var(--sac-border);\n    border-radius: 14px;\n    margin-top: 0.75rem;\n    padding: clamp(0.85rem, 1.8vw, 1.2rem);\n}\n\n.seller-action-panel__back {\n    align-items: center;\n    appearance: none;\n    background: none;\n    border: none;\n    color: var(--category-accent);\n    cursor: pointer;\n    display: inline-flex;\n    font: inherit;\n    font-size: 0.78rem;\n    font-weight: 700;\n    gap: 0.4rem;\n    margin-bottom: 0.75rem;\n    padding: 0;\n}\n\n.seller-action-panel__back:hover {\n    text-decoration: underline;\n}\n\n.seller-action-panel__back:focus-visible {\n    outline: 3px solid color-mix(in srgb, var(--category-accent) 35%, transparent);\n    outline-offset: 2px;\n}\n\n.seller-action-panel--invoices {\n    --category-accent: #4963a8;\n    --category-soft: #edf0fa;\n}\n\n.seller-action-panel--orders {\n    --category-accent: #b05f22;\n    --category-soft: #fbefe6;\n}\n\n.seller-action-panel--website {\n    --category-accent: #8a477f;\n    --category-soft: #f7ebf5;\n}\n\n.seller-action-panel--payments {\n    --category-accent: #267b70;\n    --category-soft: #e7f5f2;\n}\n\n.seller-action-panel--integrations {\n    --category-accent: #7255a5;\n    --category-soft: #f0ebf8;\n}\n\n.seller-action-panel--analytics {\n    --category-accent: #28719a;\n    --category-soft: #e7f3f8;\n}\n\n.seller-action-panel--help {\n    --category-accent: #a54b5e;\n    --category-soft: #faeaee;\n}\n\n@keyframes seller-action-panel-in {\n    from {\n        opacity: 0;\n        transform: translateY(-6px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.seller-action-panel__heading {\n    align-items: center;\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 0.8rem;\n}\n\n.seller-action-panel__heading p {\n    color: var(--category-accent);\n    font-size: 0.7rem;\n    font-weight: 800;\n    letter-spacing: 0.09em;\n    margin: 0 0 0.15rem;\n    text-transform: uppercase;\n}\n\n.seller-action-panel__heading h3 {\n    color: var(--sac-ink);\n    font-size: 1.15rem;\n    letter-spacing: -0.015em;\n    margin: 0;\n}\n\n.seller-action-panel__grid {\n    display: grid;\n    gap: 0.7rem;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.seller-action-tile {\n    background:\n        linear-gradient(\n            145deg,\n            color-mix(in srgb, var(--category-soft) 22%, #fff) 0,\n            #fff 62%\n        );\n    border: 1px solid color-mix(in srgb, var(--category-accent) 16%, var(--sac-border));\n    border-radius: 11px;\n    box-shadow: 0 2px 8px rgba(29, 46, 35, 0.04);\n    display: flex;\n    flex-direction: column;\n    min-height: 166px;\n    overflow: visible;\n    position: relative;\n    transition:\n        border-color 160ms ease,\n        box-shadow 160ms ease,\n        transform 160ms ease;\n}\n\n.seller-action-tile::before {\n    background: var(--category-accent);\n    border-radius: 2px;\n    bottom: 14px;\n    content: '';\n    left: -1px;\n    position: absolute;\n    top: 14px;\n    width: 2px;\n    opacity: 0.5;\n}\n\n.seller-action-tile:hover {\n    border-color: color-mix(in srgb, var(--category-accent) 42%, var(--sac-border));\n    box-shadow: 0 7px 18px rgba(29, 46, 35, 0.08);\n    transform: translateY(-1px);\n}\n\n.seller-action-tile__main {\n    color: inherit;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    padding: 0.85rem 0.85rem 0.6rem 0.95rem;\n    text-decoration: none;\n}\n\n.seller-action-tile__main:focus-visible {\n    border-radius: 11px;\n    outline: 3px solid color-mix(in srgb, var(--category-accent) 35%, transparent);\n    outline-offset: -3px;\n}\n\n.seller-action-tile__icon {\n    align-items: center;\n    background: color-mix(in srgb, var(--category-soft) 76%, #fff);\n    border: 1px solid color-mix(in srgb, var(--category-accent) 16%, transparent);\n    border-radius: 8px;\n    color: var(--category-accent);\n    display: inline-flex;\n    font-size: 0.95rem;\n    height: 36px;\n    justify-content: center;\n    margin-bottom: 0.65rem;\n    width: 36px;\n}\n\n.seller-action-tile__copy {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.seller-action-tile__copy strong {\n    color: var(--sac-ink);\n    font-size: 0.98rem;\n    line-height: 1.25;\n}\n\n.seller-action-tile__copy > span {\n    color: var(--sac-muted);\n    font-size: 0.78rem;\n    line-height: 1.45;\n}\n\n.seller-action-tile__open {\n    align-items: center;\n    align-self: flex-start;\n    color: var(--category-accent);\n    display: inline-flex;\n    font-size: 0.7rem;\n    font-weight: 800;\n    gap: 0.4rem;\n    margin-top: 0.55rem;\n}\n\n.seller-action-tile__open i {\n    font-size: 0.65rem;\n    transition: transform 160ms ease;\n}\n\n.seller-action-tile__main:hover .seller-action-tile__open i {\n    transform: translateX(3px);\n}\n\n.seller-action-tile__help {\n    border-top: 1px solid var(--sac-border);\n    background: color-mix(in srgb, var(--category-soft) 14%, transparent);\n    border-radius: 0 0 10px 10px;\n    padding: 0.5rem 0.85rem 0.55rem 0.95rem;\n}\n\n.seller-action-tile__help .hal-label {\n    color: var(--category-accent);\n    font-size: 0.72rem;\n    font-weight: 600;\n}\n\n.seller-action-tile__help .hal-icon {\n    background: var(--category-accent);\n}\n\n@media (max-width: 980px) {\n    .seller-action-center__categories {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .seller-action-panel__grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 560px) {\n    .seller-action-center {\n        padding: 0.65rem;\n    }\n\n    .seller-action-center > h2 {\n        font-size: 1.1rem;\n        margin-bottom: 0.55rem;\n    }\n\n    .seller-action-center__header {\n        margin: 0 0 0.65rem;\n    }\n\n    .seller-action-center__header p {\n        font-size: 0.78rem;\n        line-height: 1.35;\n    }\n\n    .seller-action-center__header strong {\n        font-size: 0.62rem;\n        margin-bottom: 0.1rem;\n    }\n\n    .seller-action-center__spark {\n        display: none;\n    }\n\n    .seller-action-center__categories {\n        gap: 0.45rem;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .seller-action-category {\n        gap: 0.4rem;\n        min-height: 106px;\n        padding: 0.6rem;\n    }\n\n    .seller-action-category__icon {\n        border-radius: 7px;\n        font-size: 0.8rem;\n        height: 30px;\n        width: 30px;\n    }\n\n    .seller-action-category__copy {\n        gap: 0;\n    }\n\n    .seller-action-category__copy strong {\n        font-size: 0.78rem;\n        line-height: 1.15;\n    }\n\n    .seller-action-category__copy span {\n        display: none;\n    }\n\n    .seller-action-category__meta {\n        font-size: 0.62rem;\n    }\n\n    .seller-action-panel {\n        margin-top: 0.55rem;\n        padding: 0.65rem;\n        scroll-margin-top: 0.75rem;\n    }\n\n    .seller-action-panel__back {\n        font-size: 0.72rem;\n        margin-bottom: 0.55rem;\n    }\n\n    .seller-action-panel__heading {\n        gap: 0.55rem;\n        margin-bottom: 0.6rem;\n    }\n\n    .seller-action-panel__heading p {\n        font-size: 0.6rem;\n        letter-spacing: 0.06em;\n    }\n\n    .seller-action-panel__heading h3 {\n        font-size: 0.95rem;\n    }\n\n    .seller-action-panel__grid {\n        gap: 0.5rem;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .seller-action-tile, div.page article.seller-action-tile {\n        min-height: 0;\n        padding: 0.5rem;\n    }\n\n    .seller-action-tile__main {\n        padding: 0.65rem 0.6rem 0.5rem 0.7rem;\n    }\n\n    .seller-action-tile__icon {\n        font-size: 0.78rem;\n        height: 30px;\n        margin-bottom: 0.45rem;\n        width: 30px;\n    }\n\n    .seller-action-tile__copy {\n        gap: 0;\n    }\n\n    .seller-action-tile__copy strong {\n        font-size: 0.78rem;\n        line-height: 1.2;\n    }\n\n    .seller-action-tile__copy > span {\n        display: none;\n    }\n\n    .seller-action-tile__open {\n        font-size: 0.62rem;\n        margin-top: 0.4rem;\n    }\n\n    .seller-action-tile__help {\n        padding: 0.4rem 0.6rem 0.45rem 0.7rem;\n    }\n\n    .seller-action-tile__help .hal-label {\n        font-size: 0.64rem;\n    }\n}\n\n@media (min-width: 440px) and (max-width: 560px) {\n    .seller-action-center__categories {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .seller-action-category,\n    .seller-action-category::before,\n    .seller-action-category__meta i,\n    .seller-action-panel,\n    .seller-action-tile,\n    .seller-action-tile::before,\n    .seller-action-tile__open i {\n        animation: none;\n        transition: none;\n    }\n}\n\n[data-theme=\"dark\"] .seller-action-center {\n    --sac-border: #3a463e;\n    --sac-ink: #e3ece6;\n    --sac-muted: #aab8af;\n    background:\n        radial-gradient(circle at 100% 0, rgba(93, 158, 77, 0.07), transparent 22rem),\n        #17221b;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.24);\n}\n\n[data-theme=\"dark\"] .seller-action-center__spark {\n    background: #223129;\n    border-color: #3a523e;\n    color: #9bd381;\n}\n\n[data-theme=\"dark\"] .seller-action-category,\n[data-theme=\"dark\"] .seller-action-panel {\n    background: #1c2620;\n}\n\n[data-theme=\"dark\"] .seller-action-tile {\n    background:\n        linear-gradient(\n            145deg,\n            color-mix(in srgb, var(--category-accent) 6%, #1c2620) 0,\n            #1c2620 62%\n        );\n}\n\n[data-theme=\"dark\"] .seller-action-category--expanded {\n    background: color-mix(in srgb, var(--category-soft) 8%, #1c2620);\n}\n\n[data-theme=\"dark\"] .seller-action-category__icon,\n[data-theme=\"dark\"] .seller-action-panel__icon {\n    background: color-mix(in srgb, var(--category-accent) 18%, #1c2620);\n}\n\n[data-theme=\"dark\"] .seller-action-tile__icon {\n    background: color-mix(in srgb, var(--category-accent) 12%, #1c2620);\n    border-color: color-mix(in srgb, var(--category-accent) 24%, #1c2620);\n}\n\n[data-theme=\"dark\"] .seller-action-tile__help {\n    background: color-mix(in srgb, var(--category-accent) 4%, #1c2620);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
